
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class Template extends Vue {
  @Prop({ default: () => {}, type: Object })
  campaignInfo: any;
  @Prop({ default: false, type: Boolean })
  active: boolean;
}
